import type { BundleMessageLocation } from './BundleMessageLocation.js';

export interface BundleMessageNote {
  text: string;
  location?: BundleMessageLocation;
}
